import React, { Fragment } from "react";
import "./timelineRegister.scss";

const dots = [{ label: "Identificação" }, { label: "Pagamento" }, { label: "Finalização" }];

const TimelineRegister = props => (
  <ul className="timeline-buy">
    {dots.map((dot, index) => {
      const isLastChild = dots.length === index + 1;
      const active = props.step >= index ? "active" : "";
      const activeLine = props.step > index ? "activeLine" : "";

      return (
        <Fragment key={index}>
          <li
            className={`timeline-buy-item ${active} ${activeLine} step-${index} ${isLastChild ? `isLastChild` : ""}`}
          />
          <span className={`timeline-buy-label ${active} step-${index}`}>{dot.label}</span>
        </Fragment>
      );
    })}
  </ul>
);

export default TimelineRegister;
